/* ============================================================
   THE UGLY SOCKS — custom-ugly.js
   Hero carousel + product carousel + ATC handler
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── HERO CAROUSEL ── */
  (function () {
    var banner  = document.getElementById('heroBanner');
    if (!banner) return;
    var slides  = banner.querySelectorAll('.hero-slide');
    if (!slides.length) return;
    var fill    = document.getElementById('heroFill');
    var num     = document.getElementById('heroNum');
    var numMob  = document.getElementById('heroNumMobile');
    var btnPrev = document.getElementById('heroPrev');
    var btnNext = document.getElementById('heroNext');
    var mdots   = banner.querySelectorAll('#heroDotsMobile .hdot');
    var DURATION = 4500;
    var current = 0, timer;

    function goTo(n) {
      slides[current].classList.remove('active');
      slides[current].classList.add('exit');
      if (mdots[current]) mdots[current].classList.remove('active');
      var prev = current;
      setTimeout(function () { slides[prev].classList.remove('exit'); }, 700);
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (mdots[current]) mdots[current].classList.add('active');
      if (num) num.textContent = current + 1;
      if (numMob) numMob.textContent = current + 1;
      startProgress();
    }

    function startProgress() {
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.transition = 'width ' + DURATION + 'ms linear';
          fill.style.width = '100%';
        });
      });
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, DURATION);
      startProgress();
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); startAuto(); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); startAuto(); });
    mdots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(+d.dataset.idx); startAuto(); });
    });

    var tx = 0;
    banner.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    banner.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) { goTo(dx < 0 ? current + 1 : current - 1); startAuto(); }
    }, { passive: true });

    startAuto();
  })();

  /* ── PRODUCT CAROUSEL ── */
  (function () {
    document.querySelectorAll('.ugly-products-track').forEach(function (track) {
      var cards = track.querySelectorAll('.prod-card');
      if (!cards.length) return;
      var outer   = track.closest('.ugly-products-outer');
      var btnPrev = outer && outer.querySelector('.ugly-carousel-prev');
      var btnNext = outer && outer.querySelector('.ugly-carousel-next');

      function cardWidth() { return cards[0].getBoundingClientRect().width + 10; }
      function scrollAmt() { return cardWidth() * (window.innerWidth <= 900 ? 2 : 3); }

      function updateArrows() {
        if (btnPrev) btnPrev.classList.toggle('disabled', track.scrollLeft <= 0);
        if (btnNext) btnNext.classList.toggle('disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 1);
      }

      if (btnPrev) btnPrev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmt(), behavior: 'smooth' });
      });
      if (btnNext) btnNext.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmt(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });

      /* mouse drag */
      var isDragging = false, startX = 0, startScroll = 0;
      track.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      document.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
      });

      updateArrows();
    });
  })();

  /* ── PINS CAROUSEL ── */
  (function () {
    var track = document.getElementById('uglyPinsTrack');
    if (!track) return;
    var cards = track.querySelectorAll('.prod-card');
    if (!cards.length) return;
    var current = 0;

    function getVisible() { return window.innerWidth <= 900 ? 2 : 3; }
    function cardWidth()  { return cards[0].getBoundingClientRect().width + 10; }
    function maxIndex()   { return Math.max(0, cards.length - getVisible()); }

    function goTo(n, instant) {
      current = Math.max(0, Math.min(n, maxIndex()));
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (current * cardWidth()) + 'px)';
      if (instant) requestAnimationFrame(function () { requestAnimationFrame(function () { track.style.transition = ''; }); });
    }

    var tx = 0, startX = 0;
    track.addEventListener('touchstart', function (e) {
      tx = e.touches[0].clientX;
      startX = -(current * cardWidth());
      track.style.transition = 'none';
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      track.style.transform = 'translateX(' + (startX + e.touches[0].clientX - tx) + 'px)';
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      track.style.transition = '';
      var dx = e.changedTouches[0].clientX - tx;
      goTo(Math.abs(dx) > 40 ? (dx < 0 ? current + 1 : current - 1) : current);
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(0, true); });
    goTo(0, true);
  })();

  /* ── ADD TO CART HANDLER ── */
  if (!window._uglyAtcBound) {
    window._uglyAtcBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ugly-atc[data-variant-id]');
      if (!btn) return;
      e.preventDefault();
      var variantId = parseInt(btn.dataset.variantId);
      var original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added!';
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      });
    });
  }

});
